import { useState, useCallback } from 'react'
import { OrgTemplates } from 'features/networkAi/types'
import { useIntl } from 'react-intl'
import {
  TemplateListRow,
  TemplateListItemBody,
  TemplateListIcon,
  TemplateListLeftBlock,
  TemplateListRightBlock,
  TemplateListDeleteIcon,
  TemplateListLeftBlockSecondary,
  TemplateListLeftBlockRadio,
  TemplateListLeftBlockName,
} from './styles'
import { mdiWifi, mdiDeleteOutline } from '@mdi/js'
import theme from 'theme_'
import RadioField from './RadioField'
import { networkWLANsMessages } from 'features/networkAi/NetworkDashboard/NetworkWLANs/messages'
import { commonMessages } from 'app/i18n/messages'
import { useAppDispatch } from 'app/hooks'
import ConfirmModal from 'components/Modal/ConfirmModal'
import { deleteOrgTemplatesThunk } from 'features/networkAi/slice'
import { DeleteOrgTemplate } from 'features/networkAi/types'

interface CreateTemplateTemplateItemProps {
  orgTemplate: OrgTemplates
  onSelectedTemplate: Function
}

function CreateTemplateTemplateItem({
  orgTemplate,
  onSelectedTemplate,
}: CreateTemplateTemplateItemProps) {
  const { formatMessage } = useIntl()
  const [templateChecked, setTemplateChecked] = useState(false)
  const [isDeleteTemplateModalOpen, setIsDeleteTemplateModalOpen] =
    useState(false)
  const dispatch = useAppDispatch()

  const handleConfirmToDeleteTemplate = useCallback(() => {
    setIsDeleteTemplateModalOpen(true)
  }, [setIsDeleteTemplateModalOpen])

  const handleConfirmDeleteTemplate = useCallback(() => {
    const deleteBody: DeleteOrgTemplate = { name: orgTemplate.name }
    dispatch(deleteOrgTemplatesThunk(orgTemplate.orgId, deleteBody))

    setIsDeleteTemplateModalOpen(false)
  }, [dispatch, orgTemplate, setIsDeleteTemplateModalOpen])

  const handleSelectTemplateClick = () => {
    onSelectedTemplate(!templateChecked, orgTemplate.id)
    setTemplateChecked(!templateChecked)
  }

  function formatTimestamp(timestamp: number) {
    try {
      const milliseconds = timestamp * 1000
      const dateObject = new Date(milliseconds)
      const humanDateFormat = dateObject.toLocaleString()
      return humanDateFormat
    } catch (e) {
      console.log(e)
      return timestamp
    }
  }

  return (
    <div id={orgTemplate.name}>
      <ConfirmModal
        isOpen={isDeleteTemplateModalOpen}
        title={formatMessage(networkWLANsMessages.titleDeleteTemplate)}
        confirmBtnTitle={formatMessage(
          networkWLANsMessages.confirmDeleteMessage
        )}
        discardBtnTitle={formatMessage(commonMessages.cancel)}
        variant="primary"
        onConfirm={handleConfirmDeleteTemplate}
        onDiscard={() => setIsDeleteTemplateModalOpen(false)}
      >
        {formatMessage(commonMessages.promptConfirm)}
        {formatMessage(networkWLANsMessages.titleDeleteTemplate)}{' '}
        {orgTemplate.name}?
      </ConfirmModal>
      <TemplateListRow>
        <TemplateListLeftBlockRadio onClick={handleSelectTemplateClick}>
          <RadioField
            value={orgTemplate.name}
            inputId={orgTemplate.name}
            isChecked={templateChecked}
            name="template_picker"
            onChange={(e: any) => setTemplateChecked(e.target.checked)}
          />
          <TemplateListIcon
            path={mdiWifi}
            size={1.5}
            color={theme.colors.otterWarmBlack}
          />
        </TemplateListLeftBlockRadio>

        <TemplateListLeftBlockName>
          {orgTemplate.name}
        </TemplateListLeftBlockName>

        <TemplateListLeftBlock>
          <TemplateListItemBody>
            {orgTemplate.wlans.length}
          </TemplateListItemBody>
        </TemplateListLeftBlock>

        <TemplateListLeftBlockSecondary>
          <TemplateListItemBody>
            {formatTimestamp(orgTemplate.created)}
          </TemplateListItemBody>
        </TemplateListLeftBlockSecondary>

        <TemplateListRightBlock>
          <TemplateListItemBody onClick={handleConfirmToDeleteTemplate}>
            <TemplateListDeleteIcon
              path={mdiDeleteOutline}
              size={1}
              color={theme.colors.horizonOrange}
            />
          </TemplateListItemBody>
        </TemplateListRightBlock>
      </TemplateListRow>
    </div>
  )
}

export default CreateTemplateTemplateItem
